// CS Ticket compose dialog shown from the conversation card.
// Mirrors the dialog#cs-compose structure in the approved HTML.
//
// TODO(runtime): submit routes to POST /v1/actions/ZOHO_CREATE_TICKET
// once that adapter is implemented. ZOHO_ASSIGN_TICKET (existing) is for
// pre-created tickets. Blocking per the sidecar open question.
import type { FormEvent, ReactNode } from 'react';
import { useEffect, useRef, useState } from 'react';
import { CURRENT_ACTION_MOCK } from '../mockData.js';
import { SARAH } from '../../../data/mockData.js';

export interface CsTicketDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (issueSummary: string) => void;
  attachedChannelLabel: string;
}

export function CsTicketDialog(props: CsTicketDialogProps): ReactNode {
  const { open, onClose, onConfirm, attachedChannelLabel } = props;
  const dialogRef = useRef<HTMLDialogElement | null>(null);
  const [issue, setIssue] = useState(CURRENT_ACTION_MOCK.ticketIssue);

  useEffect(() => {
    const el = dialogRef.current;
    if (!el) return;
    if (open && !el.open) {
      el.showModal();
    } else if (!open && el.open) {
      el.close();
    }
  }, [open]);

  function submit(event: FormEvent<HTMLFormElement>): void {
    event.preventDefault();
    const trimmed = issue.trim();
    if (!trimmed) return;
    onConfirm(trimmed);
  }

  return (
    <dialog id="cs-compose" className="cs-compose" ref={dialogRef} onClose={onClose}>
      <header>
        <h2>Create CS Ticket</h2>
        <button type="button" id="close-help" aria-label="Close" onClick={onClose}>
          &times;
        </button>
      </header>
      <form id="cs-help-form" onSubmit={submit}>
        <div className="cs-customer">
          <span className="avatar">{SARAH.initials}</span>
          <div>
            <strong>{SARAH.fullName}</strong>
            <p id="attached-channel">{attachedChannelLabel}</p>
          </div>
        </div>
        <span className="prepared-badge">Prepared by the system · Ready for your confirmation</span>
        <label htmlFor="cs-issue">Issue summary</label>
        <textarea
          id="cs-issue"
          required
          value={issue}
          onChange={(e) => setIssue(e.target.value)}
        />
        <dl className="ticket-fields">
          <dt>Customer</dt>
          <dd>{SARAH.fullName}</dd>
          <dt>Contact</dt>
          <dd>
            {SARAH.email}
            <br />
            {SARAH.phone}
          </dd>
          <dt>Related order</dt>
          <dd>{CURRENT_ACTION_MOCK.orderId} · Example linked order</dd>
          <dt>Product / quantity</dt>
          <dd>Gut X · 1 bottle reported damaged</dd>
          <dt>Category</dt>
          <dd>Damaged item</dd>
          <dt>Destination</dt>
          <dd>Customer Service · Help Desk</dd>
          <dt>Conversation</dt>
          <dd id="ticket-channel">{attachedChannelLabel}</dd>
        </dl>
        <div className="cs-attached">
          {'✓ Customer and conversation context attached'}
          <br />
          {'✓ No matching open ticket in this example'}
          <br />
          {'✓ Automatic handling checked; CS resolution needed'}
        </div>
        <p className="cs-note">
          Review the details above. The system fills information from the customer record and
          conversation; missing or uncertain details must be flagged, not guessed. No refund or
          replacement is promised.
        </p>
        <footer>
          <span>Illustrative ticket · No live submission</span>
          <button className="cs-submit" type="submit">
            Confirm &rarr;
          </button>
        </footer>
      </form>
    </dialog>
  );
}
